<template>
  <div class="reset-password-dialog">
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" width="400px" center @close="handleClose">
      <div class="dialogitem">
        <el-input placeholder="请输入密码" v-model="password" type="password" clearable show-password
          @blur="checkPasswords"></el-input>
        <div class="dialoglabel">密码不少于6位，且必须包含英文字母和数字,支持特殊符号</div>
      </div>
      <div class="dialogitem">
        <el-input placeholder="请再次输入密码" v-model="againpassword" type="password" clearable show-password
          @blur="checkPasswords"></el-input>
      </div>
      <div class="dialogitem">
        <div class="dialogiteml">
          <el-input placeholder="请输入图形验证码" v-model="imgcode" @input="checkPasswords"></el-input>
        </div>
        <div class="dialogitemr">
          <div @click="refreshverification" v-html="verificationsvg" class="verification"></div>
        </div>
      </div>
      <div class="dialogitem">
        <div class="dialogiteml">
          <el-input placeholder="请输入短信验证码" v-model="passcode" type="number" @input="checkPLength"
            class="num-input"></el-input>
        </div>
        <div class="dialogitemr">
          <el-button :disabled="send" @click="aginSend">{{ content }}</el-button>
        </div>
      </div>
      <div class="dialogitem">
        <el-button type="primary" @click="SetPwds" :loading="loading" :disabled="SetPwdssend">重置密码</el-button>
      </div>
      <div class="dialogitem errmsg" v-show="iserrmsg">手机号格式不正确</div>
      <div class="dialogitem errmsg" v-show="codeerrmsg">
        {{ codeerrcon }}
      </div>
    </el-dialog>
  </div>
</template>

<script>
import md5 from 'js-md5';
// 和 Web 登录弹窗复用同一套接口封装（@/api/ai/login）。
// 重置密码相关接口（Auth/GetCodeImg、Auth/APPSendCode、Auth/SetPwd、F_UserInfo/GetUserInfoByToken）
// 全部在 https://loginf.lawxp.com/，与登录接口同域；传输层由 login.js 内部适配：
// Web / Electron 走 axios（fetch），仅 Tauri 因 WebView 跨域限制才落到 IPC。
import {
  getIP,
  getCodeImg,
  sendVerificationCode,
  setPassword,
  getUserInfo
} from '@/api/ai/login';
export default {
  name: 'ResetPasswordDialog',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      password: '',
      againpassword: '',
      passcode: '',
      imgcode: '',
      send: true,
      content: '发送验证码',
      totalTime: 60,
      verification: '',
      verificationsvg: '',
      iserrmsg: false,
      codeerrmsg: false,
      codeerrcon: '',
      imgKey: '',
      ipAddress: '',
      username: '',
      SetPwdssend: true
    }
  },
  computed: {
    dialogTitle() {
      return '重置密码';
    }
  },
  watch: {
    '$store.getters.showResetPasswordDialog'(newVal) {
      this.dialogVisible = newVal;
      if (newVal) {
        this.initData();
      }
    }
  },
  mounted() {
    this.dialogVisible = this.$store.getters.showResetPasswordDialog;
    if (this.dialogVisible) {
      this.initData();
    }
  },
  methods: {
    async initData() {
      try {
        await this.fetchIPAddress();
        await this.fetchUserInfo();
      } catch (error) {
        console.error('初始化数据失败:', error);
      }
    },

    // 获取IP地址
    async fetchIPAddress() {
      try {
        const response = await getIP();
        if (response && response.code === 10000) {
          this.ipAddress = response.data;
          console.log('获取IP地址成功:', this.ipAddress);
          this.imgKey = md5(this.ipAddress + new Date().getTime());
          this.refreshverification();
        }
      } catch (error) {
        console.error('获取IP地址失败:', error);
      }
    },

    // 获取用户信息
    async fetchUserInfo() {
      try {
        const token = sessionStorage.getItem('pctoken');
        if (token) {
          const response = await getUserInfo({ token }, {
            "authorization": `Bearer ${token}`,
            "accept": "application/json, text/plain, */*",
            "accept-language": "zh,en;q=0.9",
            "cache-control": "no-cache",
            "content-type": "application/json;charset=UTF-8"
          });
          if (response && response.code === 0 && response.data) {
            this.username = response.data.mobilePhone;
            console.log('获取用户信息成功:', this.username);
          }
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
      }
    },

    async refreshverification() {
      try {
        const baseURL = 'https://loginf.lawxp.com/';
        const url = baseURL + 'Auth/GetCodeImg?ImgKey=' + this.imgKey;
        console.log('获取图形验证码请求URL:', url);
        const response = await getCodeImg(this.imgKey);
        // axios 已解包 response.data：接口直接返回 base64 图片字符串
        this.verificationsvg = `<img src="${response}" style="width: 100%; height: 100%; cursor: pointer;" />`;
      } catch (error) {
        console.error('获取图形验证码失败:', error);
      }
    },

    checkPLength() {
      if (this.passcode.length > 6) {
        this.passcode = this.passcode.slice(0, 6);
      }
      this.checkPasswords();
    },

    checkPasswords() {
      if (
        this.password.length > 0 &&
        this.againpassword.length > 0
      ) {
        if (this.password == this.againpassword) {
          if (this.password.length >= 6) {
            const regex = /(?=.*[0-9])(?=.*[a-zA-Z]).+$/;
            if (!regex.test(this.password)) {
              this.$message.error('密码必须包含英文字母和数字');
            } else {
              if (this.imgcode.length > 0) {
                this.send = false;
                if (this.passcode.length > 0) {
                  this.SetPwdssend = false;
                }
              }
            }
          } else {
            this.$message.error('密码不少于6位');
          }
        } else {
          this.$message.error('两次输入的密码不一致');
        }
      }
    },

    countDown() {
      this.send = true;
      this.content = this.totalTime + "s后重新发送";
      let clock = setInterval(() => {
        this.totalTime--;
        this.content = this.totalTime + "s后重新发送";
        if (this.totalTime <= 0) {
          window.clearInterval(clock);
          this.content = "重新发送";
          this.totalTime = 60;
          this.checkPasswords();
        }
      }, 1000);
    },

    aginSend() {
      if (this.username) {
        if (!this.imgcode) {
          this.$message.error("请输入图形验证码");
          return;
        }
        let num = new Date().getTime();
        let data = {
          mobilePhone: this.username.replace(/\s/gi, ""),
          Phone: "",
          Msg: "尊敬的用户，验证码：{0}，有效期10分钟，请勿泄漏给他人，如非本人操作，请忽略此消息。",
          DeviceType: "H5",
          Ip: this.ipAddress || "H5",
          Time: num,
          sign: md5(",H5," + this.ipAddress + ",," + num + "," + "JSU$E&H@F"),
          source: 20,
          imgCode: this.imgcode,
          imgKey: this.imgKey
        };
        const baseURL = 'https://loginf.lawxp.com/';
        const url = baseURL + 'Auth/APPSendCode';
        console.log('发送验证码请求URL:', url);
        console.log('发送验证码上传参数:', data);
        sendVerificationCode(data)
          .then((res) => {
            console.log('发送验证码响应:', res);
            if (res && res.code === 0) {
              this.countDown();
              this.$message.success('验证码发送成功');
            } else {
              this.refreshverification();
              this.$message.error(res?.message || '发送验证码失败，请稍后重试');
            }
          })
          .catch((err) => {
            console.error('发送验证码失败:', err);
          });
      } else {
        this.$message.error('获取用户信息失败，请重新登录');
      }
    },

    SetPwds() {
      if (!this.username) {
        this.$message.error('获取用户信息失败，请重新登录');
        return;
      }
      this.loading = true;
      try {
        let num2 = new Date().getTime();
        let data2 = {
          Phone: this.username.replace(/\s/gi, ""),
          DeviceType: "H5",
          Ip: "H5",
          Time: num2,
          sign: md5(
            this.passcode +
            ",H5,H5," +
            this.username +
            "," +
            num2 +
            "," +
            "JSU$E&H@F"
          ),
          pwd: this.password,
          code: this.passcode,
        };
        const baseURL = 'https://loginf.lawxp.com/';
        const url = baseURL + 'Auth/SetPwd';
        console.log('重置密码请求URL:', url);
        console.log('重置密码上传参数:', data2);
        setPassword(data2)
          .then((res) => {
            console.log('重置密码响应:', res);
            if (res && res.code === 0) {
              this.$message.success('重置成功');
              this.dialogVisible = false;
              // 重置成功后可以选择跳转到登录页面或其他操作
            } else {
              this.$message.error(res?.message || '重置密码失败，请稍后重试');
            }
          })
          .catch((err) => {
            console.error('重置密码失败:', err);
          })
          .finally(() => {
            this.loading = false;
          });
      } catch (error) {
        console.error('重置密码失败:', error);
        this.$message.error('重置密码失败，请稍后重试');
        this.loading = false;
      }
    },

    // 打开弹窗
    openDialog() {
      this.dialogVisible = true;
      this.initData();
    },

    // 关闭弹窗
    closeDialog() {
      this.dialogVisible = false;
    },

    // 处理弹窗关闭事件
    handleClose() {
      this.$store.commit('SET_SHOW_RESET_PASSWORD_DIALOG', false);
    }
  }
}
</script>

<style scoped lang="less">
.num-input ::v-deep .el-input__inner[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.num-input ::v-deep .el-input__inner[type="number"]::-webkit-outer-spin-button,
.num-input ::v-deep .el-input__inner[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.reset-password-dialog {
  ::v-deep .el-dialog {
    border-radius: 8px;
  }

  ::v-deep .el-dialog__header {
    text-align: center;
    padding-top: 30px;
  }

  ::v-deep .el-dialog__title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
  }

  ::v-deep .el-dialog__body {
    padding: 30px 40px;
  }

  ::v-deep .el-dialog__footer {
    padding-bottom: 30px;
  }

  .dialogitem {
    margin-bottom: 10px;
    position: relative;

    &.errmsg {
      text-align: center;
      color: #f56c6c;
      font-size: 12px;
      margin-top: 0px;
    }
  }

  .dialogiteml {
    width: 70%;
    display: inline-block;
  }

  .dialogitemr {
    width: 28%;
    display: inline-block;
    vertical-align: top;
    margin-left: 2%;
  }

  .verification {
    width: 100%;
    height: 40px;
    cursor: pointer;
  }

  .dialoglabel {
    cursor: pointer;
    font-size: 12px;
    color: #999;
    margin-top: 5px;
  }

  ::v-deep .el-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 40px;
    padding: 12px 2px;
    font-size: 12px;

    & span {
      width: 100%;
      text-align: center;
      line-height: 1;
    }
  }

  ::v-deep .el-checkbox {
    font-size: 12px;

    +.dialoglabel {
      display: inline-block;
      margin-left: 5px;
      margin-top: 0;
    }
  }

  ::v-deep .el-link {
    font-size: 12px;
  }
}
</style>